var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.2002L19.5 10.2002M19.5 10.2002L14.5 5.2002M19.5 10.2002H7.5M7.5 1.2002H6.3C4.61984 1.2002 3.77976 1.2002 3.13803 1.52718C2.57354 1.8148 2.1146 2.27374 1.82698 2.83822C1.5 3.47996 1.5 4.32004 1.5 6.0002V14.4002C1.5 16.0804 1.5 16.9204 1.82698 17.5622C2.1146 18.1267 2.57354 18.5856 3.13803 18.8732C3.77976 19.2002 4.61984 19.2002 6.3 19.2002H7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b74c7278482a115d8130242e6d8360b0.svg";
export { ForwardRef as ReactComponent };